module.exports = __webpack_public_path__ + "img/shky.a5457848.jpg";